import { Loader2 } from "lucide-react";

interface LoaderProps {
  size?: "sm" | "md" | "lg";
  fullScreen?: boolean;
}

export const Loader = ({
  size = "md",
  fullScreen = false,
}: LoaderProps = {}) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  if (fullScreen) {
    return (
      <div className="flex items-center justify-center">
        <Loader2 className={`${sizeClasses[size]} animate-spin`} />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-64">
      <Loader2 className={`${sizeClasses[size]} animate-spin`} />
    </div>
  );
};
